export default __webpack_public_path__ + "static/media/SR.48ef992b.svg";